import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import NoSsr from '@material-ui/core/NoSsr';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';

import cn from 'classnames';
import moment from 'moment';

import { Card, CardText, CardTitle } from 'react-md';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';

import './ProjectPicker.scss';

// TODO: rewrite block code below to follow eslint rules
/* eslint-disable */
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: `${theme.spacing(0.5)}px ${theme.spacing(0.25)}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}
const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};
/* eslint-enable */

class ProjectPicker extends React.Component {
  constructor(props) {
    super();
    const { defaultDate, dateFormat } = props;
    let date;
    try {
      date = moment(defaultDate).format(dateFormat);
    } catch (e) {
      date = moment(new Date()).format(dateFormat);
    }
    this.state = {
      date,
    };
  }

  handleChange = name => event => {
    const { value } = event.target;
    const { fetchProducts } = this.props;
    switch (name) {
      case 'date': {
        const { dateFormat } = this.props;
        const momentObj = moment(value, dateFormat);
        if (momentObj != null || momentObj.isValid()) {
          fetchProducts(momentObj.toDate());
          this.setState({
            date: momentObj.toDate(),
          });
        }
        break;
      }
      default:
        this.setState({
          [name]: value,
        });
    }
  };

  handleSelectChange = name => option => {
    const { selectProduct } = this.props;
    const { date } = this.state;
    switch (name) {
      case 'product': {
        if (option && option.value) {
          const { dateFormat } = this.props;
          const momentObj = moment(date, dateFormat);
          if (momentObj != null || momentObj.isValid()) {
            selectProduct({ value: option.value, date: momentObj.toDate() });
          }
          this.setState({
            [name]: option,
          });
        }
        break;
      }
      default:
        this.setState({
          [name]: option,
        });
    }
  };

  render() {
    const {
      classes,
      dateLabel,
      productLabel,
      productPlaceholder,
      data,
      isDisabled,
      isLoading,
      isClearable,
      isSearchable,
      widgetTitle,
      widgetSubTitle,
      theme,
    } = this.props;
    const { date } = this.state;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    return (
      <div className="ProjectPicker">
        <Card className="ProjectPicker-Card">
          <CardTitle title={widgetTitle} subtitle={widgetSubTitle} />
          <CardText>
            <form className={classes.container} autoComplete="off">
              <div className="Date">
                <TextField
                  id="date"
                  label={dateLabel}
                  type="date"
                  required
                  className={cn('text-date', classes.textField)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  defaultValue={date}
                  onChange={this.handleChange('date')}
                />
              </div>
              <div className={`${classes.root} Product`}>
                <NoSsr>
                  <Select
                    classes={classes}
                    styles={selectStyles}
                    isDisabled={isDisabled}
                    isLoading={isLoading}
                    isClearable={isClearable}
                    isSearchable={isSearchable}
                    name="product"
                    options={data}
                    components={components}
                    placeholder={productPlaceholder}
                    textFieldProps={{
                      label: productLabel,
                      InputLabelProps: {
                        shrink: true,
                      },
                    }}
                    onChange={this.handleSelectChange('product')}
                  />
                </NoSsr>
              </div>
            </form>
          </CardText>
        </Card>
      </div>
    );
  }
}

ProjectPicker.propTypes = {
  classes: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  defaultDate: PropTypes.instanceOf(Date),
  dateFormat: PropTypes.string,
  dateLabel: PropTypes.string,
  productLabel: PropTypes.string,
  productPlaceholder: PropTypes.string,
  widgetTitle: PropTypes.string,
  widgetSubTitle: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
      PropTypes.number,
      PropTypes.shape({
        dataLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
      }),
    ])
  ).isRequired,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  fetchProducts: PropTypes.func,
  selectProduct: PropTypes.func,
};

ProjectPicker.defaultProps = {
  defaultDate: new Date(),
  dateFormat: 'YYYY-MM-DD',
  dateLabel: 'Date',
  productLabel: 'Product',
  productPlaceholder: 'Select a product...',
  widgetSubTitle: 'Select a product to start a quotation',
  widgetTitle: 'Product',
  isDisabled: false,
  isLoading: false,
  isClearable: true,
  isSearchable: true,
  fetchProducts: (...params) => {
    // eslint-disable-next-line no-console
    console.log('fetchProducts::', params);
  },
  selectProduct: (...params) => {
    // eslint-disable-next-line no-console
    console.log('selectProduct::', params);
  },
};

export default withStyles(styles, { withTheme: true })(ProjectPicker);
